module.exports = __webpack_public_path__ + "img/examine-agree.f3046f64.png";